import { Star } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Cell, Pie, PieChart } from "recharts";

export default function RateChart({ survey }) {
  const COLORS = [
    "rgb(238, 88, 39)",
    "rgb(238, 39, 88)",
    "rgb(88, 39, 238)",
    "rgb(39, 88, 238)",
    "rgb(39, 238, 88)",
    "rgb(88, 239, 39)",
    "rgb(54, 69, 79)",
    "rgb(120, 156, 42)",
  ];

  const totalAnswers = survey.answers.reduce((a, b) => a + b.count, 0);
  const totalValues = survey.answers.reduce(
    (a, b) => a + parseInt(b.answer.split("=")[0]) * b.count,
    0
  );

  const avarage = totalValues > 0 ? (totalValues / totalAnswers).toFixed(1) : 0;

  const sortedAnswers = Array.isArray(survey.answers)
    ? [...survey.answers].sort((a, b) => b.answer - a.answer)
    : [];

  return (
    <div className="w-full p-2 px-4 border rounded-lg mb-4">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-row items-center justify-between w-full">
          <div className="flex flex-col items-start justify-start mb-2">
            <h1 className="text-md font-bold">{survey.description}</h1>
          </div>
          <div className="flex flex-col items-start justify-start mb-2">
            <h1 className="text-md font-bold flex flex-row items-center justify-center gap-1">
              <Star size={16} />
              {avarage}
            </h1>
          </div>
        </div>
      </div>
      {totalAnswers > 0 && (
        <div className="flex flex-row items-center justify-start">
          <PieChart width={200} height={200}>
            <Pie
              dataKey="count"
              data={sortedAnswers}
              cornerRadius="50%"
              outerRadius={50}
              innerRadius={40}
              paddingAngle={5}
              label
              isAnimationActive={true}
            >
              {sortedAnswers.map((entry, index) => (
                <Cell
                  key={`cell-${entry.answer}`}
                  fill={COLORS[index % COLORS.length]}
                  values={entry.count}
                />
              ))}
            </Pie>
          </PieChart>
          <div className="w-100 h-full flex flex-col align-center justify-start">
            {COLORS.map((color, index) => {
              if (!sortedAnswers[index]) return null;
              return (
                <div className="flex flex-row items-center justify-start gap-1">
                  <div
                    key={`color-${index}`}
                    className="w-2 h-2 bg-zinc-50 rounded-sm"
                    style={{ backgroundColor: color }}
                  ></div>
                  <div className="text-sm text-primary">
                    <strong>{sortedAnswers[index]?.answer_description}</strong>{" "}
                    - {sortedAnswers[index]?.count} students
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
